export default __webpack_public_path__ + "static/media/thumbnail.b3249a9b.webp";